import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Card } from "@acme/ui/card";
import { Button } from "@acme/ui/button";
import { Label } from "@acme/ui/label";
import { Switch } from "@acme/ui/switch";

export const Route = createFileRoute("/_authed/my-players/$tag/notifications")({
  component: NotificationsTab,
});

const NOTIFICATION_CHANNELS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "telegram", label: "Telegram" },
  { value: "discord", label: "Discord" },
  { value: "in_app", label: "In app" },
  { value: "push", label: "Push notification" },
  { value: "sms", label: "SMS" },
] as const;

function NotificationsTab()
{
  const [channels, setChannels] = useState<Record<string, boolean>>({
    whatsapp: false,
    telegram: false,
    discord: false,
    in_app: true,
    push: false,
    sms: false,
  });
  // Placeholder: when true, settings are out of sync → button enabled so user can sync. When false, in sync → button disabled.
  const settingsOutOfSync = false;

  const setChannel = (value: string, checked: boolean) => setChannels((prev) => ({ ...prev, [value]: checked }));

  return (
    <Card className="p-6">
      <div className="space-y-6">
        <div>
          <h2 className="text-lg font-semibold mb-1">Notification channels (placeholder)</h2>
          <p className="text-sm text-muted-foreground mb-4">
            Choose which channels to receive notifications for this player.
          </p>
          <div className="space-y-4">
            <Label>Channels</Label>
            <ul className="space-y-3">
              {NOTIFICATION_CHANNELS.map(({ value, label }) => (
                <li
                  key={value}
                  className="flex items-center justify-between rounded-lg border border-input bg-card px-4 py-3">
                  <span className="text-sm font-medium">{label}</span>
                  <Switch
                    checked={channels[value] ?? false}
                    onCheckedChange={(checked) => setChannel(value, checked)}
                    aria-label={`Enable ${label}`}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div>
          {/* disabled={!settingsOutOfSync}: enabled only when settings are out of sync, so user can pull latest; disabled when already in sync. */}
          <Button variant="secondary" size="sm" disabled={!settingsOutOfSync}>
            Sync settings by user
          </Button>
        </div>
      </div>
    </Card>
  );
}
